import React from "react";
import { API_SERVICES } from "..";
import QNuovaScheda from "../../libQuestionario/pages/QNuovaScheda";
import PDTAHeader from "./components/MRHeader";

const PDTAScheda = () => {
  return <QNuovaScheda
    homeRoute={API_SERVICES.MR.HOME_ROUTE}
    root={API_SERVICES.MR.ROOT}
    headerComponent={<PDTAHeader label="Questionario" />}
  />
}

export default PDTAScheda